<tm-info-confirm
  (afterConfirm)="afterConfirm.emit()"
  (afterCancel)="afterCancel.emit()">
</tm-info-confirm>
